<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">

            <a-form-item label="产品名称" name="productName">
                <a-input v-model:value="searchForm.productName" placeholder="请输入产品名称" />
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <!-- <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm> -->
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <template #publish="{ record }">
                <CheckOutlined v-if="record.publish == 0" style="color: #1aad19"/>
                <CloseOutlined v-if="record.publish == 1" style="color: red"/>
            </template>

            <template #type="{record}">
                <a-tag v-if="record.type == '0'">线下</a-tag>
                <a-tag v-if="record.type == '1'">线上</a-tag>
            </template>
            <template #creditType="{ text }">
                <dict-render :dict-obj="dictObjs['loanType']" :text="text"></dict-render>
            </template>
            <template #auditStatus="{ record }">
                <dict-render style="cursor: pointer;" @click="postAuditStatus(record)" :dict-obj="dictObjs['aduit_status']" :text="record.auditStatus"></dict-render>
            </template>
            <template #loanTime="{ record }">
                {{ momentFormat(record.loanTime,'YYYY-MM-DD') }}
            </template>
            <template #creditTime="{ record }">
                {{ momentFormat(record.creditTime,'YYYY-MM-DD') }}
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->
                    <!-- <a  @click="onEdit(record)">服务状态修改</a> -->
                    <a  @click="onDetail(record)">查看</a>

                    <!-- <a @click="onEdit(record)">编辑</a> -->
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <Detail ref="detailmodal" :form-primary-key-field="listKeyField" @finish="onFormEdited" @onCloseModel="onCloseModel"/>
</template>

<script>
import AddOrEditModal from "./components/AddOrEditModal";
import {tableListMixin, dictMixin} from "@/mixins";
import {financeLoan} from "@/api/finance";
import DictRender from "@/components/other/DictRender";
import Detail from "./components/Detail";
const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "产品名称", dataIndex: "productName", key: "productName", },
    {title: "企业名称", dataIndex: "companyName", key: "companyName"},
    {title: "联系人", dataIndex: "contact", key: "contact"},
    {title: "联系电话", dataIndex: "contactNumber", key: "contactNumber"},
    {title: "申请贷款额度（万元）", dataIndex: "loanAmount", key: "loanAmount"},

    // {title: "类型", dataIndex: "creditType", key: "creditType", slots: {customRender: "creditType"}},
    // {title: "处理类型", dataIndex: "type", key: "type", slots: {customRender: "type"}},
    // {title: "授信金额", dataIndex: "creditAmount", key: "creditAmount"},
    // {title: "贷款时间", dataIndex: "loanTime", key: "loanTime", slots: {customRender: "loanTime"}},
    // {title: "授信时间", dataIndex: "creditTime", key: "creditTime", slots: {customRender: "creditTime"}},
    // {title: "审核人", dataIndex: "auditor", key: "auditor"},
    // {title: "申请备注", dataIndex: "applicationRemarks", key: "applicationRemarks"},
    // {title: "审核状态", dataIndex: "auditStatus", key: "auditStatus", slots: {customRender: "auditStatus"}, fixed:'right'},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "金融产品申请",
    mixins: [tableListMixin,dictMixin],
    components: {
        AddOrEditModal,
        DictRender,
        Detail,
    },
    data() {
        return {
            dictNames: 'loanType,aduit_status',
            columns,
            status,
            queryParam: {},
            listUrl: financeLoan.pageList,
            listKeyField: "id",
            deleteUrl: financeLoan.remove
        }
    },
    methods: {
        onAdd() {
            this.onShowModal('modal');
        },
        postAuditStatus(record){
            if(record.auditStatus==1){
                this.status = 2
            }else{
                this.status = 1
            }
            this.postAction({
                url: financeLoan.edit,
                params: {
                    id: record.id,
                    auditStatus: this.status,
                }
            }).then(res => {
                console.log(res)
                this.loadData()
            })
        },
        onDetail(record){
            this.getAction({
                url: financeLoan.detail,
                params: {id: record.id}
            }).then(res=>{
                this.onShowModal("detailmodal", res)
            })
        },
        onEdit(record) {
            this.getAction({
                url: financeLoan.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },
    }
}
</script>

<style scoped>

</style>
